import { Routes, Route, Navigate } from 'react-router-dom';
import StudentApp from './pages/StudentApp.jsx';
import TeacherLogin from './pages/TeacherLogin.jsx';
import TeacherHost from './pages/TeacherHost.jsx';
import TeacherControl from './pages/TeacherControl.jsx';
import DeckPreviewFrame from './pages/DeckPreviewFrame.jsx';
import TeacherHistory from './pages/TeacherHistory.jsx';

// Student and teacher trees are fully separate route subtrees on purpose:
// nothing under "/" or "/join/:roomCode" ever imports teacher components,
// and TeacherHost enforces its own auth check (see TeacherHost.jsx) rather
// than trusting that the URL alone implies a teacher is looking at it.
export default function App() {
  return (
    <Routes>
      <Route path="/" element={<StudentApp />} />
      <Route path="/join/:roomCode" element={<StudentApp />} />
      <Route path="/teacher" element={<TeacherLogin />} />
      <Route path="/teacher/history" element={<TeacherHistory />} />
      {/* The projected screen keeps the URL it has always had; the control
          panel is the new one beside it, and /preview is the slide-only page
          the panel loads into its two iframes. */}
      <Route path="/teacher/host/:roomId" element={<TeacherHost />} />
      <Route path="/teacher/control/:roomId" element={<TeacherControl />} />
      <Route path="/teacher/preview/:roomId" element={<DeckPreviewFrame />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
